<template>
  <div class="container">
    <div class="generic-listing">
      <div class="row">
        <div v-if="0 < filterGroups.length || navLinks.length > 0" class="col-12 col-lg-3 generic-listing-controls pe-lg-5">
          <div :class="`d-flex flex-lg-column ` + controlClasses">
            <generic-filter :filterGroups="filterGroups" :results="filteredItems" :currentQuery="currentQuery" :hideEmptyGroup="true" :showCount="true" :navLinks="navLinks" @filterChange="onFilterChange">
              <template v-for="(_, name) in $slots" v-slot:[name]="slotData"><slot :name="name" v-bind="slotData" /></template>
            </generic-filter>
          </div>
        </div>

        <div class="col generic-listing-results" aria-live="polite">
          <div :class="`row ` + listingRowClasses">
            <div v-for="item in paginatedItems" :class="columnClasses">
              <component :is="resultComponent" :item="item">
                <template v-for="(_, name) in $slots" v-slot:[name]="slotData"><slot :name="name" v-bind="slotData" /></template>
              </component>
            </div>
          </div>
          <div ref="moreTrigger" id="generic-listing-more"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import GenericFilter from './generic-listing/generic-filter.vue';
  import VideoResult from './generic-listing/listing-items/video-result.vue';
  import NewsResult from './generic-listing/listing-items/news-result.vue';
  import ImageResult from './generic-listing/listing-items/image-result.vue';
  import ContentAssetLibraryResult from './generic-listing/listing-items/content-asset-library-result.vue';

  export default {
    components: {
      'generic-filter': GenericFilter,
      'video-result': VideoResult,
      'news-result': NewsResult,
      'image-result': ImageResult,
      'content-asset-library-result': ContentAssetLibraryResult
    },
    data() {
      let searchParams = new URLSearchParams(window.location.search)
      let d = window.wf.genericListing;
      d.filterGroups.forEach((grp) => {
        if (!d.currentQuery.filters[grp.id] || d.currentQuery.filters[grp.id].length == 0) {
          d.currentQuery.filters[grp.id] = searchParams.get(`filter_${grp.id}`) ? searchParams.get(`filter_${grp.id}`).split(';') : [];
        }
        // ensure all items have at least an empty filter
        d.items.forEach((item) => {
          if (!Array.isArray(item.filterValues[grp.id])) {
            item.filterValues[grp.id] = [];
          }
        })
      })
      d.controlClasses ??= "justify-content-end";
      d.itemsPerPage ??= 10;
      d.paginationState ??= {
        itemsShown: d.itemsPerPage
      };
      d.server ??= false;
      d.navLinks ??= [];

      return d;
    },
    computed: {
      filteredItems() {
        return this.server ? this.items : this.filterByQuery(this.currentQuery);
      },
      paginatedItems() {
        let filtered = this.filteredItems;
        return filtered.slice(0, Math.min(filtered.length, Math.max(0, this.paginationState.itemsShown)));
      }
    },
    watch: {
      currentQuery: {
        handler: function() {
          this.updateLocation();
          if(this.server) this.doSearch();
          this.paginationState.itemsShown = this.itemsPerPage;
        },
        deep: true
      }
    },
    methods: {
      filterByQuery(query) {
        let filtered = this.items.filter((item) => {
          let match = true;
          this.filterGroups.forEach((grp) => {
            let groupMatch = query.filters[grp.id].length == 0 ? true : (item.filterValues[grp.id].filter((b) => query.filters[grp.id].includes(b))).length > 0;
            match &&= groupMatch;
          });
          return match;
        });

        if (query.sort) {
          filtered.sort((a, b) => {
            let sortKey = query.sort.replace(/\-reverse$/, '');
            let aVal = a[sortKey],
              bVal = b[sortKey];
            if (sortKey == 'date') {
              aVal = Date.parse(aVal);
              bVal = Date.parse(bVal);
            }
            return (aVal < bVal ? -1 : (aVal > bVal ? 1 : 0)) * (query.sort.match(/\-reverse$/) ? -1 : 1);
          });
        };

        return filtered;
      },
      updateLocation() {
        let queryString = new URLSearchParams();
        this.filterGroups.forEach((grp) => {
          if (this.currentQuery.filters[grp.id] && this.currentQuery.filters[grp.id].length) {
            queryString.append(`filter_${grp.id}`, this.currentQuery.filters[grp.id].join(';'))
          }
        })
        window.history.replaceState(window.history.state, null, `${window.location.pathname}?${queryString.toString()}`);
      },
      checkLoadMore() {
        let scrollTop = document.scrollingElement.scrollTop + window.innerHeight;
        let moreOffsetTop = 0;
        let test = this.$refs.moreTrigger;
        while (test) {
          moreOffsetTop += test.offsetTop;
          test = test.offsetParent;
        }
        if (moreOffsetTop <= scrollTop) {
          this.paginationState.itemsShown += this.itemsPerPage
        }
      },
      loadFilteredItems() {
        this.isLoading = true;
        this.isProcessing = true;

        let query = '?';

        let c = Array.isArray(this.currentQuery.filters.category) ? this.currentQuery.filters.category.join('|') : '';
        query += 'c=' + c;

        let m = Array.isArray(this.currentQuery.filters.model) ? this.currentQuery.filters.model.join('|') : ''
        query += '&m=' + m;

        let endpoint = `${window.location.origin}/${this.culture}/images/${this.nodeid}/${query}`;

        fetch(endpoint)
          .then(response => response.json())
          .then(data => {
            this.items = data.items;
            this.filterGroups = data.filterGroups;
            this.totalItems = data.totalItems;
            this.isLoading = false;
            this.isProcessing = false;
          })
          .finally(() => {

          });
      },
      onCategoryChange() {
        this.clearFilters();
      },
      onFilterChange() {
      },
      doSearch() {
        if('localhost' == window.location.hostname) {
          // For breakouts don't reload from endpoint
        }
        else {
          this.loadFilteredItems(); 
        }

      },
      clearModelFilter() {
        this.currentQuery.filters.model = [];
      }      
    },
    mounted() {
      this.culture = window.culture ? window.culture : 'en-US'; 
      this.nodeid = window.nodeid ? window.nodeid : 0;
      
      document.addEventListener('scroll', this.checkLoadMore);

      // Infinite scroll replaced with button
      //document.addEventListener('scroll', this.checkLoadMore);

      if (this.currentQuery.category) {
       // this.doSearch(); // shouldn't have to do this upon load, because the items should already be loaded and filtered
      }         
    }
  }
</script>
